<script>
export default {
  methods: {
    tn(n, params) {
      return this.$t(this.ln + "." + n, params);
    },
  },
};
</script>
